import { getGroupId } from './getGroupId';
var getIsGroupable = function (optionName, prevOptionName) {
    var groupId = getGroupId(optionName);
    var prevGroupId = getGroupId(prevOptionName);
    return !!groupId && groupId === prevGroupId;
};
export { getIsGroupable };
